import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import * as _ from 'lodash';

export interface UsersDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
}

@Component({
  selector: 'users-tab-dialog',
  templateUrl: './users-tab-dialog.component.html',
  styleUrls: ['./users-tab-dialog.component.scss']
})
export class UsersTabDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isFormInvalid = true;

  constructor(public dialogRef: MatDialogRef<UsersTabDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: UsersDialogInf) {
  }

  ngOnInit(): void {
    this.setFormState();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data.selectedItem);
  }

  isLocalUser(): boolean {
    return this.data.selectedItem &&
        this.data.selectedItem.origin === 'ARM';
  }

  setFormState(): void {
    this.isFormInvalid = (_.isNil(this.data.selectedItem.name) || _.isEmpty(this.data.selectedItem.name)) &&
      !this.data.selectedItem.dicAttributes.some(attribute => (!_.isNil(attribute.value) && !_.isEmpty(attribute.value)));
  }
}
